import moment from 'moment';
import { ucfirst } from "../../src/plugins/uniweb/index";

/**
 * Class ScheduleManager.js
 *
 * @class ScheduleManager
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/manager/ScheduleManager.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export class ScheduleManager {
    constructor(translator) {
        this._translator = translator;
    }

    scheduleToString(schedule) {
        if(! schedule) {
            return ucfirst(this._translator.t('frequencyValues.ifNeeded', { catalog: 'app_mobile' }));
        }

        let note = "";

        let frequency = 0;
        let type = "";
        let daysOfWeek = schedule.daysOfWeek || [];
        let daysOfMonth = typeof schedule.daysOfMonth === "number" ? [schedule.daysOfMonth] : schedule.daysOfMonth || [];
        let monthsOfYear = typeof schedule.monthsOfYear === "number" ? [schedule.monthsOfYear] : schedule.monthsOfYear || [];
        let monthNames = [];

      if (schedule.intervals &&
        schedule.intervals.length === 1 &&
        !daysOfWeek.length &&
        !daysOfMonth.length &&
        !monthsOfYear.length
      ) {
        const { interval } = schedule.intervals[0];

        if (interval === 'P1D') {
          return ucfirst(this._translator.t('general.frequencyLabels.daily', { catalog: 'app_mobile' }));
        }
      }

        // Check for intervals.
        if (schedule.intervals && schedule.intervals.length) {
            schedule.intervals.forEach((interval) => {
                // Actual interval
                let i = interval.interval;
                let bool = interval.intervalOn;

                // Number: Integer between P and D/W/M/Y
                let n = parseInt(i.substring(1, i.length - 1));

                // Type: D or W of M or Y
                let _type = i[i.length - 1];

                // console.log('P', n, _type);

                // Add number to frequency;
                frequency = frequency + n;

                // Set type.
                switch (_type) {
                    case "D":
                        type = ucfirst(this._translator.t("frequency.days"));
                        break;
                    case "W":
                        type = ucfirst(this._translator.t("frequency.weeks"));
                        break;
                    case "M":
                        type = ucfirst(this._translator.t("frequency.months"));
                        break;
                    case "Y":
                        type = ucfirst(this._translator.t("frequency.years"));
                        break;
                }
            });

            note = `${ucfirst(this._translator.t("frequencyValues.beingRepeatedFor", {catalog : "app_mobile"}))} ${frequency} ${type}`;
        }

        if (daysOfWeek.length) {
            let dayNames = [];

            daysOfWeek.forEach((d) => {
                dayNames.push(
                    ucfirst(
                        this._translator.t("date." + moment().day(d).format("dddd").toLowerCase())
                    )
                );
            });

            note = ucfirst(`${note} ${this._translator.t("frequency.on")} ${dayNames.join(", ")}`.trim());
        }

        if (daysOfMonth.length && !monthsOfYear.length) {
            note = ucfirst(`${note} ${this._translator.t("frequencyValues.onThe", { catalog: 'app_mobile' }).toLowerCase()} ${daysOfMonth.join(", ")}`.trim());
        }

        // ---------

        if (monthsOfYear.length) {
            monthsOfYear.forEach((d) => {
                let paddedNumber = d < 10 ? "0" + d.toString() : d.toString();
                monthNames.push(ucfirst(this._translator.t(`date.MMMM-${paddedNumber}`)));
            });
        }

        if (monthNames.length && daysOfMonth.length) {
            let comb = [];

            // Make combination.
            monthNames.forEach((mN) => {
                daysOfMonth.forEach((dOm) => {
                    comb.push(`${dOm} ${mN} `);
                });
            });

            note = ucfirst(`${note} ${this._translator.t("frequency.on")} ${comb.join(", ")}`.trim());
        }

        return note && note != '' ? note : ucfirst(this._translator.t('general.frequencyLabels.daily', { catalog: 'app_mobile' }));
    }
}
